import { render, staticRenderFns } from "./CadPromocao.vue?vue&type=template&id=a4a30dbc&"
import script from "./CadPromocao.vue?vue&type=script&lang=js&"
export * from "./CadPromocao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports